/* eslint-disable import/namespace */
import { CorrenteCadastroZSM } from './ZSM/correnteRegrasCadastroZSM';
import { CorrenteEdicaoZSM } from './ZSM/correnteRegrasEdicaoZSM';
import { CorrenteCadastroZE } from './ZE/correnteRegrasCadastroZE';
import { CorrenteEdicaoZE } from './ZE/correnteRegrasEdicaoZE';
import { CorrenteCadastroZI } from './ZI/correnteRegrasCadastroZI';
import { CorrenteEdicaoZI } from './ZI/correnteRegrasEdicaoZI';
import { CorrenteCadastroZPC } from './ZPC/correnteRegrasCadastroZPC';
import { CorrenteEdicaoZPC } from './ZPC/correnteRegrasEdicaoZPC';
import { CorrenteCadastroZPET } from './ZPET/correnteRegrasCadastroZPET';
import { CorrenteEdicaoZPET } from './ZPET/correnteRegrasEdicaoZPET';
import { CorrenteCadastroZS } from './ZS/correnteRegrasCadastroZS';
import { CorrenteCadastroZSCidades } from './ZS/zsCidadesSelecionadas/correnteRegrasCadastroZSCidades';
import { CorrenteEdicaoZS } from './ZS/correnteRegrasEdicaoZS';
import { CorrenteCadastroZUP } from './ZUP/correnteRegrasCadastroZUP';
import { CorrenteEdicaoZUP } from './ZUP/correnteRegrasEdicaoZUP';
import { CorrenteCadastroZUT } from './ZUT/correnteRegrasCadastroZUT';
import { CorrenteEdicaoZUT } from './ZUT/correnteRegrasEdicaoZUT';
import { CorrenteCadastroZP } from './ZP/correnteRegrasCadastroZP';
import { CorrenteEdicaoZP } from './ZP/correnteRegrasEdicaoZP';
import { CorrenteEdicaoZCO } from './ZCO/correnteRegrasEdicaoZCO';
import { CorrenteCadastroZCO } from './ZCO/correnteRegrasCadastroZCO';
import { CorrenteCadastroZISF } from './ZISF/correnteRegrasCadastroZISF';
import { CorrenteEdicaoZISF } from './ZISF/correnteRegrasEdicaoZISF';
import { CorrenteEdicaoZCC } from './ZCC/correnteRegrasEdicaoZCC';
import { CorrenteCadastroZCC } from './ZCC/correnteRegrasCadastroZCC';
import { CorrenteCadastroZTT } from './ZTT/correnteRegrasCadastroZTT';
import { CorrenteEdicaoZTT } from './ZTT/correnteRegrasEdicaoZTT';
import { CorrenteCadastroZT } from './ZT/correnteRegrasCadastroZT';
import { CorrenteEdicaoZT } from './ZT/correnteRegrasEdicaoZT';
import { CorrenteCadastroZFT } from './ZFT/correnteCadastroZFT';
import { CorrenteEdicaoZFT } from './ZFT/correnteRegrasEdicaoZFT';
import { CorrenteCadastroZTC } from './ZTC/correnteRegrasCadastroZTC';
import { CorrenteEdicaoZTC } from './ZTC/correnteRegrasEdicaoZTC';
import { CorrenteCadastroZB } from './ZB/correnteRegrasCadastroZB';
import { CorrenteEdicaoZB } from './ZB/correnteRegrasEdicaoZB';
import { CorrenteCadastroZFL } from './ZFL/correnteRegrasCadastroZFL';
import { CorrenteEdicaoZFL } from './ZFL/correnteRegrasEdicaoZFL';
import { planosDiferenciadosCidadesCeara } from './selecaoCidadesPorPlano/cidadesCeara';
import { CorrenteEdicaoZSCidades } from './ZS/zsCidadesSelecionadas/correnteRegrasEdicaoZSCidades';
import { CorrenteCadastroZTA } from './ZTA/correnteRegrasCadastroZTA';
import { CorrenteEdicaoZTA } from './ZTA/correnteRegrasEdicaoZTA';
import { CorrenteCadastroZTI } from './ZTI/correnteRegrasCadastroZTI';
import { CorrenteEdicaoZTI } from './ZTI/correnteRegrasEdicaoZTI';
import { CorrenteCadastroZMC } from './ZMC/correnteRegrasCadastroZMC';
import { CorrenteEdicaoZMC } from './ZMC/correnteRegrasEdicaoZMC';
import { CorrenteCadastroZCL } from './ZCL/correnteCadastroZCL';
import { CorrenteCadastroEdicaoZCL } from './ZCL/correnteCadastroEdicaoZCL';

// eslint-disable-next-line max-lines-per-function
export const buscarRegrasPorPlano = async (
    plano,
    dependentes,
    parentescos,
    categorias,
    valoresForm,
    editar = false,
    objComparadorEdicao = null,
    isValid = false,
    idadeAssociado,
    codigoIbge,
    troca,
    subGrupoSelecionadoUpSell,
    renderizarPlanosUpSell,
    setRenderizarPlanosUpSell
) => {
    try {
        if (dependentes === '' || dependentes === null) {
            dependentes = [];
        }

        let cidadesCearaComRegrasPlanoDiferenciados = false;

        if (['ZS', 'ZSUC'].includes(plano) && planosDiferenciadosCidadesCeara.includes(codigoIbge)) {
            cidadesCearaComRegrasPlanoDiferenciados = true;
        }

        switch (plano) {
            case 'ZPC':
            case 'ZPCA':
            case 'ZPC4':
                if (!editar) {
                    const correnteZPC = new CorrenteCadastroZPC(
                        dependentes,
                        parentescos,
                        categorias,
                        valoresForm,
                        idadeAssociado,
                        subGrupoSelecionadoUpSell
                    )
                        .validarRegrasDepAtuaisComDepUpSell()
                        .verificaParentescoRepetidos()
                        .verificarLimiteMaxDependentes()
                        .validaQuantidadeMax75Anos()
                        .verificarEstrutura2()
                        .adicionalPetSomenteParaPets()
                        .possuiAdicionalDependentePet()
                        .verificarMaximo1DepComAdicional()
                        .possui3DependentesPet();
                    const { arrayMsgsErro } = correnteZPC;

                    return arrayMsgsErro;
                } else {
                    const correnteZPC = new CorrenteEdicaoZPC(
                        dependentes,
                        parentescos,
                        categorias,
                        valoresForm,
                        objComparadorEdicao
                    )
                        .infringeTipoDependente()
                        .infringeAdicionalPet()
                        .infringeQuantidadeDependentesSemValorAdicional()
                        .infringeQuantidadeDependenteEspeciais()
                        .infringeAdicionalPetPrime();
                    const { arrayMsgsErro } = correnteZPC;

                    return arrayMsgsErro;
                }

            case 'ZP':
            case 'ZPA':
            case 'ZP4':
                if (!editar) {
                    const correnteZP = new CorrenteCadastroZP(
                        dependentes,
                        parentescos,
                        categorias,
                        valoresForm,
                        idadeAssociado,
                        subGrupoSelecionadoUpSell
                    )
                        .validarRegrasDepAtuaisComDepUpSell()
                        .verificaParentescoRepetidos()
                        .verificarLimiteMaxDependentes()
                        .validaQuantidadeMax75Anos()
                        .verificarEstrutura1()
                        .verificarEstrutura2()
                        .adicionalPetSomenteParaPets()
                        .possuiAdicionalDependentePet()
                        .verificarMaximo1DepComAdicional()
                        .possui3DependentesPet();

                    const { arrayMsgsErro } = correnteZP;

                    return arrayMsgsErro;
                } else {
                    const correnteZP = new CorrenteEdicaoZP(
                        dependentes,
                        parentescos,
                        categorias,
                        valoresForm,
                        objComparadorEdicao
                    )
                        .infringeTipoDependente()
                        .infringeAdicionalPet()
                        .infringeQuantidadeDependentesSemValorAdicional()
                        .infringeQuantidadeDependenteEspeciais()
                        .infringeAdicionalPetPrime();
                    const { arrayMsgsErro } = correnteZP;

                    return arrayMsgsErro;
                }

            case 'ZUP':
            case 'ZUPC':
            case 'ZUPC6':
            case 'ZUP65':
                if (!editar) {
                    const correnteZUP = new CorrenteCadastroZUP(
                        dependentes,
                        parentescos,
                        categorias,
                        valoresForm
                    )
                        .possuiConjuge()
                        .conjugeSomenteSemValorAdicional();
                    const { arrayMsgsErro } = correnteZUP;

                    return arrayMsgsErro;
                } else {
                    const correnteZUP = new CorrenteEdicaoZUP(
                        dependentes,
                        parentescos,
                        categorias,
                        valoresForm,
                        objComparadorEdicao
                    ).infringeConjugue()
                        .infringeConjugueQuandoNaoCadastrado()
                        .infringeValorAdicionalConjugeQuandoJaCadastrado()
                        .infringeValorAdicionalQuando18anos()
                        .infringeValorAdicionalQuandoMaior18anosMenor64()
                        .infringeValorAdicionalQuandoMaior65();
                    const { arrayMsgsErro } = correnteZUP;

                    return arrayMsgsErro;
                }

            case 'ZUT':
            case 'ZUTC':
            case 'ZUTC6':
            case 'ZUT65':
                if (!editar) {
                    const correnteZUT = new CorrenteCadastroZUT(
                        dependentes,
                        parentescos,
                        categorias,
                        valoresForm,
                        isValid
                    )
                        .possuiConjuge()
                        .conjugeSomenteSemValorAdicional();
                    const { arrayMsgsErro } = correnteZUT;

                    return arrayMsgsErro;
                } else {
                    const correnteZUT = new CorrenteEdicaoZUT(
                        dependentes,
                        parentescos,
                        categorias,
                        valoresForm,
                        objComparadorEdicao
                    ).infringeConjugue()
                        .infringeConjugueQuandoNaoCadastrado()
                        .infringeValorAdicionalConjugeQuandoJaCadastrado()
                        .infringeValorAdicionalQuando18anos()
                        .infringeValorAdicionalQuandoMaior18anosMenor64()
                        .infringeValorAdicionalQuandoMaior65();

                    const { arrayMsgsErro } = correnteZUT;

                    return arrayMsgsErro;
                }

            case 'ZI':
                if (!editar) {
                    const correnteZI = new CorrenteCadastroZI(
                        dependentes,
                        parentescos,
                        categorias,
                        valoresForm,
                        subGrupoSelecionadoUpSell
                    )
                        .validarRegrasDepAtuaisComDepUpSell()
                        .possui5dependentes()
                        .parentescoEmDuplicidade()
                        .permitirDependentePetSomenteComAdicionalPet()
                        .limitarQuantidadePet();
                    const { arrayMsgsErro } = correnteZI;

                    return arrayMsgsErro;
                } else {
                    const correnteZI = new CorrenteEdicaoZI(
                        dependentes,
                        parentescos,
                        categorias,
                        valoresForm,
                        objComparadorEdicao
                    );

                    const { arrayMsgsErro } = correnteZI;

                    return arrayMsgsErro;
                }

            case 'ZFT':
                if (!editar) {
                    const correnteZS = new CorrenteCadastroZFT(
                        dependentes,
                        parentescos,
                        categorias,
                        valoresForm
                    )
                        .parentescosSemValorAdicional()
                        .parentescosSemValorAdicionalRegrasEspeciais()
                        .possui14Dependentes()
                        .parentescosComAdicionalElegivelAte64()
                        .parentescosComAdicionalElegivelMaiorIgual65()
                        .parentescoComAdicionalAte64()
                        .parentescoComAdicionalMaiorIgual65()
                        .parentescosComAdicionalElegivelAte64()
                        .parentescosComAdicionalElegivelMaiorIgual65()
                        .exConjugeComAdicionalAte64()
                        .exConjugeComAdicionalMaiorIgual65()
                        .paiComAdicionalAte64()
                        .paiComAdicionalMaiorIgual65()
                        .maeComAdicionalAte64()
                        .maeComAdicionalMaiorIgual65()
                        .conjugeComAdicionalAte64()
                        .conjugeComAdicionalMaiorIgual65()
                        .madrastaComAdicionalAte64()
                        .madrastaComAdicionalMaiorIgual65()
                        .padrastoComAdicionalAte64()
                        .padrastoComAdicionalMaiorIgual65()
                        .excecaoPetPorLocalidade()
                        .permitirDependentePetSomenteComAdicionalPet();

                    const { arrayMsgsErro } = correnteZS;

                    return arrayMsgsErro;
                } else {
                    const correnteZS = new CorrenteEdicaoZFT(
                        dependentes,
                        parentescos,
                        categorias,
                        valoresForm,
                        objComparadorEdicao
                    )
                        .infringeParentescoSemAdicional()
                        .infringeParentescosSemValorAdicionalRegrasEspeciais()
                        .infringeParentescoComAdicionalAte64()
                        .infringeParentescoComAdicionalMaiorIgual65()
                        .parentescosComAdicionalElegivelAte64()
                        .parentescosComAdicionalElegivelMaiorIgual65()
                        .exConjugeComAdicionalAte64()
                        .exConjugeComAdicionalMaiorIgual65()
                        .paiComAdicionalAte64()
                        .paiComAdicionalMaiorIgual65()
                        .maeComAdicionalAte64()
                        .maeComAdicionalMaiorIgual65()
                        .conjugeComAdicionalAte64()
                        .conjugeComAdicionalMaiorIgual65()
                        .madrastaComAdicionalAte64()
                        .madrastaComAdicionalMaiorIgual65()
                        .padrastoComAdicionalAte64()
                        .padrastoComAdicionalMaiorIgual65()
                        .excecaoPetPorLocalidade()
                        .permitirDependentePetSomenteComAdicionalPet();

                    const { arrayMsgsErro } = correnteZS;

                    return arrayMsgsErro;
                }

            case 'ZB':
            case 'ZBC':
                if (!editar) {
                    const correnteCadastroZB = new CorrenteCadastroZB(
                        dependentes,
                        parentescos,
                        categorias,
                        valoresForm
                    )
                        .validarIdadeMaior75()
                        .verificarPossui3Dependentes()
                        .validarParentesco()
                        .validarCategoriasPlano()

                        .parentescoEpecialComAdicionalAte65()
                        .parentescoEspecialComAdicionalMaior65()
                        .parentescoEmDuplicidade();

                    const { arrayMsgsErro } = correnteCadastroZB;

                    return arrayMsgsErro;
                } else {
                    const correnteEdicaoZB = new CorrenteEdicaoZB(
                        dependentes,
                        parentescos,
                        categorias,
                        valoresForm,
                        objComparadorEdicao
                    )
                        .verificarMudancaCategoria()

                        .parentescoEmDuplicidade()
                        .parentescoEpecialComAdicionalAte65()
                        .parentescoEspecialComAdicionalMaior65();

                    const { arrayMsgsErro } = correnteEdicaoZB;

                    return arrayMsgsErro;
                }

            case 'ZFL':
            case 'ZFLC':
                if (!editar) {
                    const correnteCadastroZFL = new CorrenteCadastroZFL(
                        dependentes,
                        parentescos,
                        categorias,
                        valoresForm,
                        idadeAssociado
                    )

                        .verificarPossui5Dependentes()
                        .validaSequenciaDependentes()
                        .validarQtdDependentesAcima65Anos()
                        .validarCategoriasPlano()
                        .parentescoEpecialComAdicionalAte65()
                        .parentescoEspecialComAdicionalMaior65()
                        .parentescoEmDuplicidade();

                    const { arrayMsgsErro } = correnteCadastroZFL;

                    return arrayMsgsErro;
                } else {
                    const correnteCadastroZFL = new CorrenteEdicaoZFL(
                        dependentes,
                        parentescos,
                        categorias,
                        valoresForm,
                        objComparadorEdicao,
                        idadeAssociado
                    )

                        .validarQtdDependentesAcima65Anos()
                        .verificarMudancaIdade()
                        .verificarMudancaCategoria()
                        .parentescoEmDuplicidade()
                        .parentescoEpecialComAdicionalAte65()
                        .parentescoEspecialComAdicionalMaior65();

                    const { arrayMsgsErro } = correnteCadastroZFL;

                    return arrayMsgsErro;
                }

            case 'ZE':
            case 'ZFC':
            case 'ZEC':
            case 'ZF':
                if (!editar) {
                    const correnteZE = new CorrenteCadastroZE(
                        dependentes,
                        parentescos,
                        categorias,
                        valoresForm
                    )
                        .infringeParentescoSemAdicional()
                        .possui14Dependentes()
                        .parentescoComAdicionalAte64()
                        .parentescoComAdicionalMaiorIgual65()
                        .exConjugeComAdicionalAte64()
                        .exConjugeComAdicionalMaiorIgual65()
                        .conjugeComAdicionalAte64()
                        .conjugeComAdicionalMaiorIgual65()
                        .permitirSomenteConjugeSemValorAdicional()
                        .permitirSomenteMaeSemValorAdicional()
                        .permitirSomentePaiSemValorAdicional()
                        .madrastaComAdicionalAte64()
                        .madrastaComAdicionalMaiorIgual65()
                        .paiComAdicionalAte64()
                        .paiComAdicionalMaiorIgual65()
                        .maeComAdicionalAte64()
                        .maeComAdicionalMaiorIgual65()
                        .padrastoComAdicionalAte64()
                        .padrastoComAdicionalMaiorIgual65()
                        .parentescosComAdicionalElegivelAte64()
                        .parentescosComAdicionalElegivelAte65()
                        .parentescoEmDuplicidade()
                        .excecaoPetPorLocalidade()
                        .permitirDependentePetSomenteComAdicionalPet()
                        .limitarQuantidadePet();

                    const { arrayMsgsErro } = correnteZE;

                    return arrayMsgsErro;
                } else {
                    const correnteZE = new CorrenteEdicaoZE(
                        dependentes,
                        parentescos,
                        categorias,
                        valoresForm,
                        objComparadorEdicao
                    ).infringeParentescoSemAdicional()
                        .infringeParentescoComAdicionalAte64()
                        .infringeParentescoComAdicionalMaiorIgual65()
                        .conjugeComAdicionalAte64()
                        .conjugeComAdicionalMaiorIgual65()
                        .exConjugeComAdicionalAte64()
                        .exConjugeComAdicionalMaiorIgual65()
                        .madrastaComAdicionalAte64()
                        .madrastaComAdicionalMaiorIgual65()
                        .padrastoComAdicionalAte64()
                        .padrastoComAdicionalMaiorIgual65()
                        .paiComAdicionalAte64()
                        .paiComAdicionalMaiorIgual65()
                        .maeComAdicionalAte64()
                        .maeComAdicionalMaiorIgual65()
                        .permitirSomenteConjugeSemValorAdicional()
                        .permitirSomenteMaeSemValorAdicional()
                        .permitirSomentePaiSemValorAdicional()
                        .parentescosComAdicionalElegivelAte64()
                        .parentescosComAdicionalElegivelAte65()
                        .parentescoEmDuplicidade()
                        .excecaoPetPorLocalidade()
                        .permitirDependentePetSomenteComAdicionalPet()
                        .limitarQuantidadePet();

                    const { arrayMsgsErro } = correnteZE;

                    return arrayMsgsErro;
                }

            case 'ZT':
            case 'ZT65':
            case 'ZTC65':
                if (!editar) {
                    const correnteZT = new CorrenteCadastroZT(
                        dependentes,
                        parentescos,
                        categorias,
                        valoresForm
                    )
                        .possui14Dependentes()
                        .parentescoComAdicionalAte64()
                        .parentescoComAdicionalMaiorIgual65()
                        .parentescoEmDuplicidade()
                        .excecaoPetPorLocalidade()
                        .permitirDependentePetSomenteComAdicionalPet()
                        .limitarQuantidadePet();

                    const { arrayMsgsErro } = correnteZT;

                    return arrayMsgsErro;
                } else {
                    const correnteZT = new CorrenteEdicaoZT(
                        dependentes,
                        parentescos,
                        categorias,
                        valoresForm,
                        objComparadorEdicao
                    )
                        .infringeParentescoComAdicionalAte64()
                        .infringeParentescoComAdicionalMaiorIgual65()
                        .parentescoEmDuplicidade()
                        .excecaoPetPorLocalidade()
                        .permitirDependentePetSomenteComAdicionalPet()
                        .limitarQuantidadePet();

                    const { arrayMsgsErro } = correnteZT;

                    return arrayMsgsErro;
                }

            case 'ZTT':
                if (!editar) {
                    const correnteZTT = new CorrenteCadastroZTT(
                        dependentes,
                        parentescos,
                        categorias,
                        valoresForm
                    )
                        .possui14Dependentes()
                        .parentescoComAdicionalAte64()
                        .parentescoComAdicionalMaiorIgual65()
                        .parentescoEmDuplicidade()
                        .excecaoPetPorLocalidade()
                        .permitirDependentePetSomenteComAdicionalPet();

                    const { arrayMsgsErro } = correnteZTT;

                    return arrayMsgsErro;
                } else {
                    const correnteZTT = new CorrenteEdicaoZTT(
                        dependentes,
                        parentescos,
                        categorias,
                        valoresForm,
                        objComparadorEdicao
                    )
                        .infringeParentescoComAdicionalAte64()
                        .infringeParentescoComAdicionalMaiorIgual65()
                        .parentescoEmDuplicidade()
                        .excecaoPetPorLocalidade()
                        .permitirDependentePetSomenteComAdicionalPet();

                    const { arrayMsgsErro } = correnteZTT;

                    return arrayMsgsErro;
                }

            case 'ZTC':
                if (!editar) {
                    const correnteZTC = new CorrenteCadastroZTC(
                        dependentes,
                        parentescos,
                        categorias,
                        valoresForm
                    )
                        .possui14Dependentes()
                        .parentescoComAdicionalAte64()
                        .parentescoComAdicionalMaiorIgual65()
                        .excecaoPetPorLocalidade()
                        .permitirDependentePetSomenteComAdicionalPet()
                        .limitarQuantidadePet();

                    const { arrayMsgsErro } = correnteZTC;

                    return arrayMsgsErro;
                } else {
                    const correnteZTC = new CorrenteEdicaoZTC(
                        dependentes,
                        parentescos,
                        categorias,
                        valoresForm,
                        objComparadorEdicao
                    )
                        .infringeParentescoComAdicionalAte64()
                        .infringeParentescoComAdicionalMaiorIgual65()
                        .excecaoPetPorLocalidade()
                        .permitirDependentePetSomenteComAdicionalPet()
                        .limitarQuantidadePet();

                    const { arrayMsgsErro } = correnteZTC;

                    return arrayMsgsErro;
                }

            case 'ZTA':
                if (!editar) {
                    const correnteZTA = new CorrenteCadastroZTA(
                        dependentes,
                        parentescos,
                        categorias,
                        valoresForm
                    ).possui14dependentes();
                    const { arrayMsgsErro } = correnteZTA;

                    return arrayMsgsErro;
                } else {
                    const correnteZTA = new CorrenteEdicaoZTA(
                        dependentes,
                        parentescos,
                        categorias,
                        valoresForm,
                        objComparadorEdicao
                    );

                    const { arrayMsgsErro } = correnteZTA;

                    return arrayMsgsErro;
                }

            case 'ZS':
            case 'ZSUC':
                if (!editar) {
                    if (cidadesCearaComRegrasPlanoDiferenciados) {
                        const correnteZSCidades = new CorrenteCadastroZSCidades(
                            dependentes,
                            parentescos,
                            categorias,
                            valoresForm,
                            idadeAssociado,
                            troca,
                            subGrupoSelecionadoUpSell
                        )
                            .validarRegrasDepAtuaisComDepUpSell()
                            .parentescoEmDuplicidade()
                            .parentescosSemValorAdicional()
                            .verificarIdadeDependentes()
                            .validarQtdDependentesAcima65Anos()
                            .validarCategoriasPlano()
                            .verificarQuantidadeDependentes()
                            .validaSequenciaDependentes();

                        const { arrayMsgsErro } = correnteZSCidades;

                        return arrayMsgsErro;
                    }

                    const correnteZS = new CorrenteCadastroZS(
                        dependentes,
                        parentescos,
                        categorias,
                        valoresForm,
                        subGrupoSelecionadoUpSell,
                        setRenderizarPlanosUpSell,
                        renderizarPlanosUpSell
                    )
                        .validarRegrasDepAtuaisComDepUpSell()
                        .parentescosSemValorAdicional()
                        .parentescosSemValorAdicionalRegrasEspeciais()
                        .possui14Dependentes()
                        .parentescosComAdicionalElegivelAte64()
                        .parentescosComAdicionalElegivelMaiorIgual65()
                        .parentescoComAdicionalAte64()
                        .parentescoComAdicionalMaiorIgual65()
                        .exConjugeComAdicionalAte64()
                        .exConjugeComAdicionalMaiorIgual65()
                        .paiComAdicionalAte64()
                        .paiComAdicionalMaiorIgual65()
                        .maeComAdicionalAte64()
                        .maeComAdicionalMaiorIgual65()
                        .conjugeComAdicionalAte64()
                        .conjugeComAdicionalMaiorIgual65()
                        .madrastaComAdicionalAte64()
                        .madrastaComAdicionalMaiorIgual65()
                        .padrastoComAdicionalAte64()
                        .padrastoComAdicionalMaiorIgual65()
                        .parentescoEmDuplicidade()
                        .excecaoPetPorLocalidade()
                        .permitirDependentePetSomenteComAdicionalPet()
                        .limitarQuantidadePet();

                    const { arrayMsgsErro } = correnteZS;

                    return arrayMsgsErro;
                } else {
                    if (cidadesCearaComRegrasPlanoDiferenciados) {
                        const correnteZSCidades = new CorrenteEdicaoZSCidades(
                            dependentes,
                            parentescos,
                            categorias,
                            valoresForm,
                            idadeAssociado,
                            troca,
                            subGrupoSelecionadoUpSell
                        )
                            .parentescoEmDuplicidade()
                            .validarQtdDependentesAcima65Anos()
                            .verificarIdadeDependentes()
                            .verificarQuantidadeDependentes()
                            .validarCategoriasPlano();

                        const { arrayMsgsErro } = correnteZSCidades;

                        return arrayMsgsErro;
                    }

                    const correnteZS = new CorrenteEdicaoZS(
                        dependentes,
                        parentescos,
                        categorias,
                        valoresForm,
                        objComparadorEdicao
                    )
                        .infringeParentescoSemAdicional()
                        .infringeParentescosSemValorAdicionalRegrasEspeciais()
                        .infringeParentescoComAdicionalAte64()
                        .infringeParentescoComAdicionalMaiorIgual65()
                        .parentescosComAdicionalElegivelAte64()
                        .parentescosComAdicionalElegivelMaiorIgual65()
                        .exConjugeComAdicionalAte64()
                        .exConjugeComAdicionalMaiorIgual65()
                        .paiComAdicionalAte64()
                        .paiComAdicionalMaiorIgual65()
                        .maeComAdicionalAte64()
                        .maeComAdicionalMaiorIgual65()
                        .conjugeComAdicionalAte64()
                        .conjugeComAdicionalMaiorIgual65()
                        .madrastaComAdicionalAte64()
                        .madrastaComAdicionalMaiorIgual65()
                        .padrastoComAdicionalAte64()
                        .padrastoComAdicionalMaiorIgual65()
                        .parentescoEmDuplicidade()
                        .excecaoPetPorLocalidade()
                        .permitirDependentePetSomenteComAdicionalPet()
                        .limitarQuantidadePet();

                    const { arrayMsgsErro } = correnteZS;

                    return arrayMsgsErro;
                }

            case 'ZMC':
            case 'ZMCC':
                if (!editar) {
                    const correnteZMC = new CorrenteCadastroZMC(
                        dependentes,
                        parentescos,
                        valoresForm,
                        idadeAssociado
                    )
                        .possui9Dependentes()
                        .parentescoEmDuplicidade()
                        .parentescoComAdicionalMais65();

                    const { arrayMsgsErro } = correnteZMC;

                    return arrayMsgsErro;
                } else {
                    const correnteEdicaoZMC = new CorrenteEdicaoZMC(
                        dependentes,
                        parentescos,
                        valoresForm,
                        objComparadorEdicao,
                        idadeAssociado
                    )

                        .infringeParentescoComAdicionalMais65()
                        .parentescoEmDuplicidade();

                    const { arrayMsgsErro } = correnteEdicaoZMC;

                    return arrayMsgsErro;
                }

            case 'ZPET':
            case 'ZPETN':
                if (!editar) {
                    const correnteZPET = new CorrenteCadastroZPET(
                        dependentes,
                        parentescos,
                        categorias,
                        valoresForm
                    )
                        .permitirSomente3PetsSemValorAdicional()
                        .permitirPetsComValorAdicional();

                    const { arrayMsgsErro } = correnteZPET;

                    return arrayMsgsErro;
                } else {
                    const correnteZPET = new CorrenteEdicaoZPET(
                        dependentes,
                        parentescos,
                        categorias,
                        valoresForm,
                        objComparadorEdicao
                    )

                        .permitirSomente3PetsSemValorAdicional()
                        .permitirPetsComValorAdicionalEdicao();

                    const { arrayMsgsErro } = correnteZPET;

                    return arrayMsgsErro;
                }

            case 'ZISF':
                if (!editar) {
                    const correnteZISAF = new CorrenteCadastroZISF(
                        dependentes,
                        parentescos,
                        categorias,
                        valoresForm,
                        idadeAssociado,
                        subGrupoSelecionadoUpSell
                    )
                        .validarRegrasDepAtuaisComDepUpSell()
                        .possui2DependentesMaiorIgual65Anos()
                        .dependentesDentroDaEstrutura1()
                        .possui10Dependentes()
                        .parentescoEmDuplicidade();

                    const { arrayMsgsErro } = correnteZISAF;

                    return arrayMsgsErro;
                } else {
                    const correnteZISAFEdicao = new CorrenteEdicaoZISF(
                        dependentes,
                        parentescos,
                        categorias,
                        valoresForm,
                        objComparadorEdicao,
                        idadeAssociado
                    )
                        .possui2DependentesMaiorIgual65Anos()
                        .dependentesDentroDaEstrutura1()
                        .possui10Dependentes()
                        .parentescoEmDuplicidade();

                    const { arrayMsgsErro } = correnteZISAFEdicao;

                    return arrayMsgsErro;
                }

            case 'ZCC':
                if (!editar) {
                    const correnteZCL = new CorrenteCadastroZCC(
                        dependentes,
                        parentescos,
                        categorias,
                        valoresForm
                    )
                        .possui2DependentesMaiorIgual65Anos()
                        .possui9Dependentes()
                        .parentescoEmDuplicidade();

                    const { arrayMsgsErro } = correnteZCL;

                    return arrayMsgsErro;
                } else {
                    const correnteZCL = new CorrenteEdicaoZCC(
                        dependentes,
                        parentescos,
                        categorias,
                        valoresForm,
                        objComparadorEdicao
                    )

                        .possui2DependentesMaiorIgual65Anos()
                        .possui9Dependentes()
                        .parentescoEmDuplicidade();

                    const { arrayMsgsErro } = correnteZCL;

                    return arrayMsgsErro;
                }

            case 'ZCL':
            case 'ZCLO':
                if (!editar) {
                    const correnteZCL = new CorrenteCadastroZCL(
                        dependentes,
                        valoresForm,
                        parentescos,
                        subGrupoSelecionadoUpSell
                    )
                        .validarRegrasDepAtuaisComDepUpSell()
                        .quantidadeDependentesMaximo()
                        .parentescoEmDuplicidade()
                        .verificaRepeticaoPaisPadastros()
                        .validaSequenciaDependentes();

                    const { arrayMsgsErro } = correnteZCL;

                    return arrayMsgsErro;
                } else {
                    const correnteZCL = new CorrenteCadastroEdicaoZCL(
                        dependentes,
                        valoresForm,
                        parentescos,
                        subGrupoSelecionadoUpSell
                    )
                        .parentescoEmDuplicidade()
                        .verificaRepeticaoPaisPadastros()
                        .validarCategoriasPlano()
                        .validarIdadeCategoria();

                    const { arrayMsgsErro } = correnteZCL;

                    return arrayMsgsErro;
                }

            case 'ZSM':
            case 'ZSMC':
            case 'ZSMT':
            case 'ZSMTC':
                if (!editar) {
                    const correnteZSM = new CorrenteCadastroZSM(
                        dependentes,
                        parentescos,
                        categorias,
                        valoresForm,
                        idadeAssociado
                    )
                        .possui6Dependentes()
                        .parentescoComAdicionalMais65();

                    const { arrayMsgsErro } = correnteZSM;

                    return arrayMsgsErro;
                } else {
                    const correnteZSM = new CorrenteEdicaoZSM(
                        dependentes,
                        parentescos,
                        categorias,
                        valoresForm,
                        objComparadorEdicao,
                        idadeAssociado
                    ).infringeParentescoComAdicionalMais65();

                    const { arrayMsgsErro } = correnteZSM;

                    return arrayMsgsErro;
                }

            case 'ZCO':
            case 'ZCOC':
                if (!editar) {
                    const correnteZCO = new CorrenteCadastroZCO(
                        dependentes,
                        parentescos,
                        categorias,
                        valoresForm
                    )
                        .possui8Dependentes().dependentePet();

                    const { arrayMsgsErro } = correnteZCO;

                    return arrayMsgsErro;
                } else {
                    const correnteZCO = new CorrenteEdicaoZCO(
                        dependentes,
                        parentescos,
                        categorias,
                        valoresForm,
                        objComparadorEdicao
                    ).infringeIdade().infringeParentesco();

                    const { arrayMsgsErro } = correnteZCO;

                    return arrayMsgsErro;
                }

            case 'ZTI':
            case 'ZTIC':
                if (!editar) {
                    const correnteZTI = new CorrenteCadastroZTI(
                        dependentes,
                        parentescos,
                        categorias,
                        idadeAssociado,
                        valoresForm
                    )
                        .possui14Dependentes()
                        .possui2VidasMaiorIgual79Anos()
                        .parentescoComAdicionalAte64()
                        .parentescoComAdicionalMaiorIgual65()
                        .parentescoComAdicionalMaior79()
                        .parentescoEmDuplicidade();

                    const { arrayMsgsErro } = correnteZTI;

                    return arrayMsgsErro;
                } else {
                    const correnteZTI = new CorrenteEdicaoZTI(
                        dependentes,
                        parentescos,
                        categorias,
                        idadeAssociado,
                        valoresForm,
                        objComparadorEdicao,
                        idadeAssociado
                    )
                        .infringeParentescoComAdicionalAte64()
                        .infringeParentescoComAdicionalMaiorIgual65()
                        .verificarMudancaIdade()
                        .parentescoComAdicionalMaior79()
                        .parentescoEmDuplicidade();

                    const { arrayMsgsErro } = correnteZTI;

                    return arrayMsgsErro;
                }

            default:
                return [];
        }
        // eslint-disable-next-line no-empty
    } catch (error) {
        console.error('Error (buscarRegrasPorPlano)', error);
    }
};
